"use client";

import { useEffect, useState } from "react";
import { useDebounceCallback } from "usehooks-ts";

/** True while `window.scrollY` is at or above the top within `thresholdPx`. */
export function useScrollNearTop(thresholdPx = 10): boolean {
	const [nearTop, setNearTop] = useState(true);

	const debouncedScrollHandler = useDebounceCallback(
		() => {
			setNearTop(window.scrollY <= thresholdPx);
		},
		150,
		{
			maxWait: 150,
		},
	);

	useEffect(() => {
		window.addEventListener("scroll", debouncedScrollHandler);
		debouncedScrollHandler();
		return () => {
			window.removeEventListener("scroll", debouncedScrollHandler);
		};
	}, [debouncedScrollHandler]);

	return nearTop;
}
